module.controller('printFeedCtrl', ['$scope', '$rootScope', '$state', '$stateParams', '$http', 'Session', 'baseURI', 'accountService', function ($scope, $rootScope, $state, $stateParams, $http, Session, baseURI, accountService){
  var subUrl = baseURI + 'card/sub-cards';
  var balance;

  $scope.section = $stateParams.Section;
  $scope.count = $stateParams.Count;
  $scope.toDate = $stateParams.ToDate;
  $scope.fromDate = $stateParams.FromDate;
  $scope.username = $stateParams.Username;

  if($scope.section == 'all'){
    $scope.sectionTitle = 'All';
  } else {
    $scope.sectionTitle = 'All ' + $scope.section;
  }

  var queryUrl = baseURI + 'transactions/by-date/' + $stateParams.Section + '/' + $stateParams.FromDate + '/' + $stateParams.ToDate;

  if($stateParams.Username != 'primary'){
    queryUrl = queryUrl + '/?Username=' + $stateParams.Username;
  }


  var getTransactions = function(){
    $scope.loading = true;
    $http.get(queryUrl, {cache: true}).then(function(resp){
      $scope.loading = false;
      $scope.transactions = transformFeed(resp.data.Data.Transactions).transactions;
      $scope.startDate = moment($scope.fromDate).format('MMMM Do, YYYY');
      $scope.endDate = moment($scope.toDate).format('MMMM Do, YYYY');
      setTimeout(function(){
        window.print();
      }, 1000);
    }).catch(function(err){
      $scope.loading = false;
    });
  };

  var getAccountNumber = function(){
    $http.get(baseURI + 'directdeposit', {cache: true}).then(function (resp){
      var account = resp.data.Data.Account;
      $scope.accountLastFour = account.slice(-4);
    }).catch(function (error){
      console.log('err', error);
    });
  };

  var transformFeed = function(feed){
    var akimboFeed = {};
    var notifications = [];
    var transactions = [];

    for(var f in feed){
      if(feed[f].IsNotification){
        feed[f].Id = f;
        notifications.push(feed[f]);
      } else {
        transactions.push(feed[f]);
      }
    }

    //akimboFeed.notifications = formatNotifications(notifications);
    akimboFeed.transactions = formatTransactions(transactions);

    return akimboFeed;
  };


  var formatTransactions = function(transactions){
    for(var t in transactions){
      // set index balance to current balance
      if(t === '0'){
        transactions[t].Balance = balance;
      } else {
        balance = balance - transactions[t - 1].Amount;
        transactions[t].Balance = balance;
      }
      transactions[t].FormattedDate = moment(transactions[t].Time).format('MMMM Do, YYYY');
      transactions[t].FormattedTime = moment(transactions[t].Time).format('h:mma');
    }
    return transactions;
  };

  // get transactions and account number
  getAccountNumber();

  var account = accountService.getAccount($scope.username);

  $scope.name = account.firstName + ' ' + account.lastName;
  balance = account.balance;
  $scope.balance = balance;

  getTransactions();

}]);
